// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608172044/js/" + chunkId + "." + {"44":"89a38cf3","225":"e059c171","481":"02aecb49","486":"75cb212b","770":"c0b23dcc"}[chunkId] + ".0.746906685848375.chunk.js";
};